(function () {
  var SHOPIFY_PAGE_SIZE = 50;

  function getItems(root) {
    return Array.from(root.querySelectorAll('[data-ci-load-more-item]'));
  }

  function getGridList(root) {
    return (
      root.querySelector('[data-brand-grid-list]') ||
      root.querySelector('ul#product-grid') ||
      root.querySelector('ul.product-grid') ||
      root.querySelector('ul.ci-pgrid') ||
      root.querySelector('ul.ci-cbg__grid') ||
      root.querySelector('ul.collection-list') ||
      root.querySelector('ul.ci-collections-grid')
    );
  }

  function parseCollectionHandleSet(root) {
    if (root.getAttribute('data-ci-scoped-collection-search') !== 'true') return null;
    var section = root.closest('[data-ci-brand-grid]');
    if (!section) return null;
    var source = section.querySelector('[data-ci-collection-product-handles]');
    var raw =
      (source && source.getAttribute('data-ci-collection-product-handles')) ||
      section.dataset.ciCollectionProductHandles ||
      '';
    var set = new Set();
    raw.split(',').forEach(function (handle) {
      handle = handle.trim().toLowerCase();
      if (handle) set.add(handle);
    });
    return set.size ? set : null;
  }

  function readStateFromRoot(root) {
    return {
      initial: parseInt(root.dataset.ciLoadMoreInitial || '28', 10) || 28,
      step: parseInt(root.dataset.ciLoadMoreStep || '12', 10) || 12,
      currentPage: parseInt(root.dataset.ciLoadMorePage || '1', 10) || 1,
      totalPages: parseInt(root.dataset.ciLoadMorePages || '1', 10) || 1,
      sectionId: root.dataset.ciLoadMoreSectionId || '',
    };
  }

  function createController(root) {
    var config = readStateFromRoot(root);
    var state = {
      visibleCount: config.initial,
      disabled: false,
      boundButton: null,
      loading: false,
      currentPage: config.currentPage,
      totalPages: config.totalPages,
      sectionId: config.sectionId,
      initial: config.initial,
      step: config.step,
    };

    function ensureButton() {
      var button = root.querySelector('[data-ci-load-more-button]');
      if (button && button !== state.boundButton) {
        button.addEventListener('click', onButtonClick);
        state.boundButton = button;
      }
      return button;
    }

    function hasMoreToShow(items) {
      if (state.disabled) return false;
      if (items.length > state.visibleCount) return true;
      return state.currentPage < state.totalPages;
    }

    function isAtEnd(items) {
      if (state.disabled || state.loading) return false;
      if (!items.length) return false;
      return items.length <= state.visibleCount && state.currentPage >= state.totalPages;
    }

    function update() {
      var items = getItems(root);
      var pagination = root.querySelector('[data-ci-load-more-pagination]');
      var endMessage = root.querySelector('[data-ci-load-more-end]');
      var button = ensureButton();
      var hasMore = hasMoreToShow(items);
      var atEnd = isAtEnd(items);

      if (state.disabled) {
        items.forEach(function (item) {
          item.classList.remove('is-ci-load-more-hidden');
        });
        if (pagination) pagination.hidden = true;
        if (endMessage) endMessage.hidden = true;
        return;
      }

      items.forEach(function (item, index) {
        item.classList.toggle('is-ci-load-more-hidden', index >= state.visibleCount);
      });

      if (pagination) {
        pagination.hidden = !hasMore;
      }

      if (button) {
        button.hidden = !hasMore;
        button.disabled = state.loading;
        button.setAttribute('aria-busy', state.loading ? 'true' : 'false');
      }

      if (endMessage) {
        endMessage.hidden = !atEnd;
      }
    }

    function reset() {
      var config = readStateFromRoot(root);
      state.initial = config.initial;
      state.step = config.step;
      state.currentPage = config.currentPage;
      state.totalPages = config.totalPages;
      state.sectionId = config.sectionId;
      state.visibleCount = state.initial;
      state.loading = false;
      update();
    }

    function revealMore() {
      state.visibleCount += state.step;
      update();
    }

    function setLoading(isLoading) {
      var button = root.querySelector('[data-ci-load-more-button]');
      state.loading = !!isLoading;
      root.classList.toggle('is-ci-load-more-fetching', state.loading);

      if (button) {
        if (state.loading) {
          if (!button.dataset.ciLoadMoreLabel) {
            button.dataset.ciLoadMoreLabel = button.textContent.trim();
          }
          button.textContent = 'Cargando…';
        } else if (button.dataset.ciLoadMoreLabel) {
          button.textContent = button.dataset.ciLoadMoreLabel;
        }
      }

      update();
    }

    function fetchNextPage() {
      if (!state.sectionId || state.currentPage >= state.totalPages) {
        return Promise.resolve(false);
      }

      var nextPage = state.currentPage + 1;
      var fetchPath = root.dataset.ciLoadMoreFetchPath || window.location.pathname;
      var url = new URL(fetchPath, window.location.origin);
      var params = url.searchParams;

      if (root.dataset.ciLoadMoreSearchQuery) {
        params.set('q', root.dataset.ciLoadMoreSearchQuery);
        if (fetchPath.indexOf('/search') !== -1) {
          params.set('type', 'product');
          params.set('options[unavailable_products]', 'show');
        }
      } else {
        var current = new URLSearchParams(window.location.search);
        current.forEach(function (value, key) {
          if (key === 'page' || key === 'section_id') return;
          params.append(key, value);
        });
      }

      params.set('page', String(nextPage));
      params.set('section_id', state.sectionId);

      setLoading(true);

      return fetch(url)
        .then(function (response) {
          return response.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var remoteRoot =
            doc.querySelector('#ProductGridContainer [data-ci-load-more-root]') ||
            doc.querySelector('[data-ci-load-more-root]') ||
            doc.getElementById('ProductGridContainer');
          if (!remoteRoot) return false;

          var newItems = remoteRoot.querySelectorAll('[data-ci-load-more-item]');
          var list = getGridList(root);
          if (!list || !newItems.length) return false;

          var handleSet = parseCollectionHandleSet(root);
          var appended = 0;

          newItems.forEach(function (node) {
            if (handleSet) {
              var handle = (node.getAttribute('data-product-handle') || '').trim().toLowerCase();
              if (!handle || !handleSet.has(handle)) return;
            }
            list.appendChild(document.importNode(node, true));
            appended += 1;
          });

          if (!appended) return false;

          if (handleSet) {
            root.setAttribute('data-ci-search-results-count', String(getItems(root).length));
          }

          state.currentPage = nextPage;
          root.dataset.ciLoadMorePage = String(nextPage);

          if (window.CiStorefrontProductFilter && root.getAttribute('data-ci-storefront-filter') === 'true') {
            window.CiStorefrontProductFilter.filterGrid(root);
            window.CiStorefrontProductFilter.init(root);
          }

          var section = root.closest('[data-ci-brand-grid]');
          if (section && section._ciFilters) {
            section._ciFilters.filterUnpublishedCatalogProducts();
            section._ciFilters.recountCatalogVisibleTotal();
          }

          document.dispatchEvent(
            new CustomEvent('ci:product-grid:updated', {
              detail: { root: root.closest('#ProductGridContainer') || root },
            })
          );

          return true;
        })
        .catch(function () {
          return false;
        })
        .finally(function () {
          setLoading(false);
        });
    }

    function onButtonClick() {
      if (state.loading || state.disabled) return;

      var items = getItems(root);

      if (items.length > state.visibleCount) {
        revealMore();
        return;
      }

      if (state.currentPage < state.totalPages) {
        fetchNextPage().then(function (loaded) {
          if (!loaded) {
            if (state.currentPage >= state.totalPages) {
              state.visibleCount = getItems(root).length;
            }
            update();
            return;
          }
          revealMore();
        });
        return;
      }

      state.visibleCount = items.length;
      update();
    }

    function showAll() {
      state.visibleCount = getItems(root).length;
      state.currentPage = state.totalPages;
      update();
    }

    function setDisabled(value) {
      state.disabled = !!value;
      update();
    }

    update();

    root._ciLoadMore = {
      reset: reset,
      showAll: showAll,
      setDisabled: setDisabled,
      update: update,
    };
  }

  function init(scope) {
    var roots = [];
    var target = scope || document;

    if (target.matches && target.matches('[data-ci-load-more-root]')) {
      roots.push(target);
    }

    if (target.querySelectorAll) {
      roots = roots.concat(Array.from(target.querySelectorAll('[data-ci-load-more-root]')));
    }

    roots.forEach(function (root) {
      if (root._ciLoadMore) {
        root._ciLoadMore.update();
        return;
      }
      createController(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target || document);
  });

  document.addEventListener('ci:product-grid:updated', function (event) {
    init((event && event.detail && event.detail.root) || document);
  });

  window.CiLoadMore = {
    pageSize: SHOPIFY_PAGE_SIZE,
    init: init,
  };
})();
